import React, { memo, useCallback } from 'react';
import styles from './WebLineCard.module.less';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { createSelector } from 'reselect';
import { CONTEXT } from '../../config';
import Btn from '../../components/Btn/Btn';
import gift from '../../static/search_gift.svg';
import reco from '../../static/search_reco.svg';
import sale from '../../static/search_sale.png';
import essence from '../../static/search_essence.png';
import MyLink from '../Link/Link';
import { logPostInfo, logging } from '../../actions/log';
import DEFAULTIMG from '../../static/default.svg';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ soft, logInfo = {} }) => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);

  // 专题商品文字链接
  const handleClickAD = () => {
    // 专题商品文字链接
    dispatch(
      logging({
        category: 'C',
        action: 'Search_Buy_Text',
        label: '',
        param2: {
          source: logInfo ? logInfo.source : 'LineCard_err',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          search_type: logInfoData.search_type,
          search_word: logInfoData.search_word,
          softId: soft.softID,
          softType: soft.androidType || 0,
          targetContent:
            soft && soft.activityList && soft.activityList[0].targetContent
              ? JSON.parse(soft.activityList[0].targetContent)
              : '',
          targetType: soft && soft.activityList && soft.activityList[0].targetType,
        },
        param3: soft && soft.bizInfo,
      }),
    );
    dispatch(
      logPostInfo({
        source_p: `${logInfo ? logInfo.source : 'LineCard_err'}||Search_Activity`,
        source_pp: logInfoData.source_p,
      }),
    );
  };

  const handleClick = useCallback((content = 'content') => {
    dispatch(
      logging({
        category: 'C',
        action: 'Install',
        label: '',
        param2: {
          source: logInfo.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          softid: soft && soft.softID,
          softName: soft && soft.softName,
          softType: 3, // 纯网页应用为 3;  网页版购买为 10
          type: 'o', // 更新还是下载
          url: soft && soft.targetUrl,
          content,
          search_word: logInfoData.search_word,
          search_type: logInfoData.search_type,
        },
        param3: (soft && soft.bizInfo) || null,
      }),
    );
    window.open(soft && soft.targetUrl);
  }, []);

  return (
    <div className={styles.card}>
      <div className={styles.card_content}>
        <a
          onClick={() => {
            handleClick();
          }}
        >
          <div className={styles.img_container}>
            <div className={styles.app_img}>
              <img className={styles.app_img} src={soft.logoFile || DEFAULTIMG} alt="" />
            </div>
            {soft.hasGiftBag && <img src={gift} alt="" className={styles.logo_icon} />}
            {!soft.hasGiftBag && soft.editorRecommend && (
              <img src={reco} alt="" className={styles.logo_icon} />
            )}
          </div>
        </a>
        <div className={styles.info}>
          <a
            title={soft.softName}
            onClick={() => {
              handleClick();
            }}
          >
            <div className={styles.info_container}>
              <div className={styles.title_info}>
                <div className={styles.title} title={soft.softName}>
                  {soft.softName}
                </div>
                <div className={styles.table}>
                  {soft &&
                    soft.searchTag &&
                    soft.searchTag.map((item, i) => (
                      <img src={item.icon} key={i} alt={item.name || ''} title={item.tips || ''} />
                    ))}
                </div>
              </div>
              <div className={styles.desc} title={soft.introduction}>
                {soft.introduction}
              </div>
            </div>
          </a>
          {soft.activityList && soft.activityList[0] && (
            <MyLink data={soft.activityList[0]} handleClick={handleClickAD}>
              <div className={styles.link}>
                {/* 5商品 2是外链 11专题详情 */}
                <img src={soft.activityList[0].targetType === '5' ? sale : essence} alt="" />
                <div className={styles.ad}>{soft.activityList[0].activityDesc}</div>
                <div className={styles.ad_arrow} />
              </div>
            </MyLink>
          )}
        </div>
        <div className={styles.other_info}>
          <div className={styles.other_info_text}>该软件为网页版，将启动浏览器一键直达。</div>
        </div>
        <div
          className={styles.opt_div}
          onClick={e => {
            e.stopPropagation();
          }}
        >
          <Btn
            soft={soft}
            primary
            className={styles.open_btn}
            handleClick={() => {
              handleClick('buttton');
            }}
          >
            打开
          </Btn>
        </div>
      </div>
    </div>
  );
});
